/** Virtual bundles (e.g. online coach): no meal picking, no delivery fee. */
export function isVirtualServiceBundle(bundle) {
  if (!bundle?.excludeDeliveryFee) return false;
  const m = bundle.meals;
  if (m == null) return true;
  if (Array.isArray(m) && m.length === 0) return true;
  return false;
}

export function cartItemShowsMealBreakdown(item) {
  if (item?.skipMealSelection) return false;
  return Array.isArray(item?.meals) && item.meals.length > 0;
}
